export enum KeyCode {
  Z = 90,
  Y = 89,
  X = 88,
  P = 80,
  V = 86,
  BACKSPACE = 8,
  DELETE = 46
}

export const QUOTE_SHARE_LINK_CLASS = 'quote-share-link';

export enum EditorActions {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
  REMOVE = 'remove',
  INSERT = 'insert',
  UPDATE = 'update'
}
